import { render } from "./Checkbox.vue?vue&type=template&id=13c74822&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=13c74822&lang=scss&scoped=true"
import "./Checkbox.vue?vue&type=style&index=1&id=13c74822&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c74822"]])

export default __exports__